module.exports = __webpack_public_path__ + "img/velans-ff-1.ce1aa53.jpg";